import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index.js';

const Main = () => import('../page/Main.vue');
// const Order = () => import('../page/Order.vue');
const Model = () => import('../page/Model.vue')
const Models = () => import('../page/Models.vue');
const Store = () => import('../page/Store.vue');
const About = () => import('../page/About.vue');
const History = () => import('../page/History.vue');
const AiLayout = () => import('../page/AiLayout.vue');
const PaymentSuccess = () => import('@/components/common/Success.vue');
const PaymentFailed = () => import('@/components/common/Failed.vue');
const error404 = () => import('@/components/common/Error404.vue');
const LineAuthorize = () => import('@/components/user/Authorize.vue');

Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'main',
    component: Main,
  },
  // {
  //   path: '/order',
  //   name: 'order',
  //   component: Order,
  // },
  {
    path: '/',
    component: AiLayout,
    children: [
      {
        path: 'models',
        name: 'models',
        component: Models,
      },
      {
        path: 'store',
        name: 'store',
        component: Store,
      },
      {
        path: 'history',
        name: 'history',
        component: History,
      },
    ],
  },
  {
    path: '/model/:model_hashcode',
    name: 'model',
    component: Model,
    props: true,
  },
  {
    path: '/about',
    name: 'about',
    component: About,
  },
  {
    path: '/line/authorize',
    name: 'line-authorize',
    component: LineAuthorize,
  },
  {
    path: '/payment/success',
    name: 'payment-success',
    component: PaymentSuccess,
  },
  {
    path: '/payment/failed',
    name: 'payment-failed',
    component: PaymentFailed,
  },
  {
    path: '*',
    name: 'error404',
    component: error404,
  },
]

const router = new VueRouter({
  base: '/',
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {

  // 1. 取得登入狀態
  const loginStatus = store.state.global.login;
  const loginProfile = store.state.global.profile;
  const isLoggedIn = loginStatus && loginProfile; // 這樣判斷更清晰

  // 2. 檢查頁面是否存在
  if (!to.matched.length) {
    // 頁面不存在，導向 404
    // 確保你有一個 name: 'error404' 的路由
    return next({ name: 'error404' });
  }

  // 3. 定義不需要登入的 "公開頁面" (白名單)
  // 登入頁和 LINE 授權頁都不需要登入
  const publicPages = ['login', 'line-authorize', 'store'];
  const authRequired = !publicPages.includes(to.name);

  // // --- 開始路由判斷 ---

  if (authRequired && !isLoggedIn) {
    // 情況 A：此頁面 "需要" 登入，但用戶 "未登入"
    // 檢查目的地是否已經是 'main'，如果是則放行，避免無限重導向
    if(to.name === 'main') {
      return next();
    } else {
      store.commit('global/UPDATE_MESSAGE_BOX', {
        active: true,
        type: 'error',
        content: '請先登入會員',
      })
      return next({ name: 'main' });
    }
  }

  // 情況 C：所有其他情況 (例如：已登入訪問頁面，或訪問公開頁面)
  next();
});

export default router
